import { useCallback } from 'react';
import { Onboarding } from '../../../components/onboarding/Onboarding';
import RootLayout from '../../layouts/RootLayout';
import API from '../../../lib/api';
import { useNavigate } from 'react-router-dom';

export default function OnboardingPage() {
    const navigate = useNavigate();

    const handleComplete = useCallback(() => {
        console.log('Onboarding completed!');
        // Redirect to dashboard or main app
        API.post('/user/onboarding')
            .then(() => {
                navigate('/dashboard');
            })
            .catch((err) => {
                console.log(err);
            });
    }, [navigate]);

    return (
        <RootLayout>
            <Onboarding onComplete={handleComplete} />
        </RootLayout>
    );
}
